<template>
  <div class="zx-slider" :class="{ 'is-vertical': vertical }">
    <div
      class="zx-slider__runway"
      ref="slider"
      @click="onSliderClick"
    >
      <div
        class="zx-slider__box"
        :class="{ 'hideRound': hideRound }"
        ref="slider_box"
      >
        <div
          class="zx-slider__bar"
          :style="styleBox"
          ref="slider_bar"
        ></div>
        <div
          class="zx-slider__button"
          :class="{ 'hideRound': hideRound }"
          :style="styleBtn"
          @click.stop
          @mousedown="onButtonDown"
          @touchstart="onButtonDown"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    step: {
      type: Number,
      default: 1,
    },
    vertical: {
      type: Boolean,
      default: false
    },
    hideRound: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      mValue: 0,
      startXY: 0, // 拖动时鼠标的初始位置
      startPosition: 0, // 开始拖动时原位置距离
      newPosition: 0, // 现在拖动位置距离
    };
  },
  created () {
    this.mValue = this.value;
  },
  methods: {
    // 点击调整位置
    onSliderClick (e) {
      const sliderOffsetLength = this.vertical ? this.$refs.slider.getBoundingClientRect().bottom : this.$refs.slider.getBoundingClientRect().left;
      let length = this.vertical ? (sliderOffsetLength - e.clientY) : (e.clientX - sliderOffsetLength)
      this.lengthToValue(length);
      this.$nextTick(() => {
        this.$emit('change', this.mValue);
      });
    },
    // 开始拖动
    onButtonDown (event) {
      if (event.cancelable) { // 判断是否可取消事件
        event.preventDefault(); // 阻止默认行为
      }
      this.onDragStart(event);
      window.addEventListener('mousemove', this.onDragging); // 鼠标移动
      window.addEventListener('touchmove', this.onDragging); // 手指触摸屏幕时
      window.addEventListener('mouseup', this.onDragEnd); // 鼠标按键被松开
      window.addEventListener('touchend', this.onDragEnd); // 当手指从屏幕上离开
      window.addEventListener('contextmenu', this.onDragEnd); // 在用户点击鼠标右键打开上下文菜单时触发
    },
    // 记录拖动初始信息
    onDragStart (event) {
      this.dragging = true;
      this.isClick = true;
      if (event.type === 'touchstart') {
        event.clientY = event.touches[0].clientY;
        event.clientX = event.touches[0].clientX;
      }
      this.startXY = this.vertical ? event.clientY : event.clientX;
      this.startPosition = this.vertical ? this.$refs.slider_bar.offsetHeight : this.$refs.slider_bar.offsetWidth;
      this.newPosition = this.startPosition;
      this.$emit('draggingStart', this.mValue);
    },
    // 拖动过程处理
    onDragging (event) {
      if (this.dragging) {
        this.isClick = false;
        let diff = 0; // 拖动距离
        if (event.type === 'touchmove') {
          event.clientY = event.touches[0].clientY;
          event.clientX = event.touches[0].clientX;
        }
        this.currentXY = this.vertical ? event.clientY : event.clientX;
        diff = this.currentXY - this.startXY;
        // console.log(diff, this.startPosition)
        if (this.vertical) {
          diff = -diff
        }
        // 用于将slider_box上的值换算为在slider上的值
        let proportion = this.vertical ? 
          (this.$refs.slider.offsetHeight / this.$refs.slider_box.offsetHeight) : 
          (this.$refs.slider.offsetWidth / this.$refs.slider_box.offsetWidth)
        this.newPosition = (this.startPosition + diff) * proportion;
        // console.log(this.newPosition)
        this.lengthToValue(this.newPosition);
      }
    },
    // 拖动结束
    onDragEnd () {
      if (this.dragging) {
        /*
         * 防止在 mouseup 后立即触发 click，导致滑块有几率产生一小段位移
         * 不使用 preventDefault 是因为 mouseup 和 click 没有注册在同一个 DOM 上
         */
        setTimeout(() => {
          this.dragging = false;
          if (!this.isClick) {
            this.lengthToValue(this.newPosition);
          }
          this.$nextTick(() => {
            this.$emit('draggingEnd', this.mValue);
            this.$emit('change', this.mValue);
          });
        }, 0);
        window.removeEventListener('mousemove', this.onDragging);
        window.removeEventListener('touchmove', this.onDragging);
        window.removeEventListener('mouseup', this.onDragEnd);
        window.removeEventListener('touchend', this.onDragEnd);
        window.removeEventListener('contextmenu', this.onDragEnd);
      }
    },
    // 根据位置计算值
    lengthToValue (distance) {
      const bl_cs = distance / (this.vertical ? this.$refs.slider.offsetHeight : this.$refs.slider.offsetWidth); // 点击位置的百分比
      // console.log(bl_cs)
      let z_cs = bl_cs * (this.max - this.min) + this.min; // 位置对应的数值
      let mValue = ((z_cs / this.step).toFixed(0) * this.step); // 将位置值转为合理值
      this.setMValue(mValue);
      this.$emit('changing', this.mValue);
    },
    verificationValue (value) {
      value = parseFloat(value.toFixed(this.precision));
      value = value > this.max ? this.max : value < this.min ? this.min : value;
      return value;
    },
    setMValue (value) {
      this.mValue = this.verificationValue(value);
      // console.log(this.mValue)
      this.$emit('input', this.mValue);
    }
  },
  computed: {
    styleBox () {
      return this.vertical ? {
        height: this.position_X + '%',
      } : {
        width: this.position_X + '%',
      }
    },
    styleBtn () {
      return this.vertical ? {
        bottom: this.position_X + '%',
      } : {
        left: this.position_X + '%',
      }
    },
    position_X () {
      return ((this.mValue - this.min) / (this.max - this.min)) * 100;
    },
    // 获取最长小数位
    precision () {
      let precisions = [this.min, this.max, this.step].map(item => {
        let decimal = ('' + item).split('.')[1];
        return decimal ? decimal.length : 0;
      });
      return Math.max.apply(null, precisions);
    },
  },
  watch: {
    value (newVal) {
      this.setMValue(newVal);
    },
    min () {
      let min = this.min > this.max ? this.max : this.min;
      this.$emit("update:min", min);
      this.setMValue(this.mValue);
    },
    max () {
      let max = this.max < this.min ? this.min : this.max;
      this.$emit("update:max", max);
      this.setMValue(this.mValue);
    },
    step () {
      if (this.step == 0) {
        process.env.NODE_ENV !== 'production' &&
          console.warn('[Element Warn][Slider]step should not be 0.');
        return;
      }
      let mValue = (this.mValue / this.step).toFixed(0) * this.step;
      this.setMValue(mValue);
    },
  },
};
</script>

<style lang='less' scoped>
.zx-slider {
  display: inline-block;
  width: 100px;
  --sliderBtnH: 20px; // zx-slider__button高度 
  --sliderBtnW: 20px; // zx-slider__button宽度 
  --sliderH: 6px;
  .zx-slider__runway {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: var(--sliderH);
    margin: calc((var(--sliderBtnH) - var(--sliderH)) / 2) 0;
    cursor: pointer;
    vertical-align: middle;
    border-radius: 3px;
    background-color: #E4E7ED;
  }
  .zx-slider__box {
    position: relative;
    width: calc(100% - var(--sliderBtnW)); // 解决zx-slider__button超出区域的问题
    height: 100%;
    &.hideRound {
      width: 100%;
      .zx-slider__button {
        transform: translateX(-50%) translateY(-50%);
      }
    }
  }
  .zx-slider__bar {
    position: absolute;
    height: var(--sliderH);
    // padding-right: calc(var(--sliderBtnW) / 2);
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    background-color: #409EFF;
  }
  .zx-slider__button {
    position: absolute;
    z-index: 1001;
    top: 50%;
    left: 0;
    box-sizing: border-box;
    width: var(--sliderBtnW);
    height: var(--sliderBtnH);
    user-select: none;
    transform: translateY(-50%);
    border: 2px solid #409EFF;
    border-radius: 50%;
    background-color: #FFFFFF;
    &.hideRound {
      opacity: 0;
    }
  }
  &.is-vertical {
    width: auto;
    height: 100px;
    .zx-slider__runway {
      width: var(--sliderH);
      height: 100%;
      margin: 0 16px;
    }
    .zx-slider__box {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: calc(100% - var(--sliderBtnW)); // 解决zx-slider__button超出区域的问题
      &.hideRound {
        height: 100%;
        .zx-slider__button {
          transform: translateX(-50%) translateY(50%);
        }
      }
    }
    .zx-slider__bar {
      bottom: 0;
      width: var(--sliderH);
      height: 0;
      // padding-top: calc(var(--sliderBtnW) / 2);
      padding-right: 0;
      border-radius: 0;
      border-bottom-left-radius: 3px;
      border-bottom-right-radius: 3px;
    }
    .zx-slider__button {
      top: auto;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}

</style>